/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
import { PREFIX } from "../lib/tracking/index.js";
import { otto } from "./nexus.js";

import type { OttoNexus } from "./nexus.js";

export * from "../lib/tracking/index.js";
export * from "../lib/tracking/event/event.types.js";

/**
 *
 */
export type Tracking = OttoNexus[typeof PREFIX];

/**
 *
 *
 */
export const tracking: Tracking = otto[PREFIX];

/**
 *
 *
 *
 */
export const onInit: Tracking["onInit"] = tracking.onInit;

/**
 *
 *
 *
 *
 */
export const lockInit: Tracking["lockInit"] = tracking.lockInit;
/**
 *
 *
 *
 *
 */
export const unlockInit: Tracking["unlockInit"] = tracking.unlockInit;
